import { api } from './api.js';
import { convertToUrlSearchParams } from '../utils/helper.js';

export const globalViewEndpoints = api.injectEndpoints({
    endpoints: (builder) => ({
        getGlobalView: builder.query({
            query: (params) => {
                return {
                    url: `/global-view?${convertToUrlSearchParams(params)}`,
                    method: 'GET'
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        globalAdvancedSearch: builder.query({
            query: (params) => ({
                url: `/advanced-search?${convertToUrlSearchParams(params)}`,
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getGlobalAdvancedSearchFilters: builder.query({
            query: () => ({
                url: '/misc/advanced-search-filters',
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getCountriesByContinent: builder.query({
            query: () => ({
                url: '/misc/continent-countries',
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        })
    })
});

export const {
    useLazyGetGlobalViewQuery,
    useLazyGlobalAdvancedSearchQuery,
    useGetGlobalAdvancedSearchFiltersQuery,
    useGetCountriesByContinentQuery
} = globalViewEndpoints;
